export default __webpack_public_path__ + "static/media/11AW1NOV65.d9725622.jpg";